<template>
  <div class="space-y-6">
    <!-- Header with Crystal Image -->
    <div class="flex items-center justify-between">
      <div class="h-1 flex-1 bg-primary/20 rounded"></div>
      <img src="https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fflower-life-sacred-geometry.webp?alt=media&token=851535c9-cfb0-4264-8369-c7d0795b2d01" alt="Crystal" class="w-30 h-10 mx-3" />
      <div class="h-1 flex-1 bg-primary/20 rounded"></div>
    </div>

    <!-- Main Content -->
    <div class="bg-white rounded-lg overflow-hidden">
      <div class="relative">
        <img
          src="https://firebasestorage.googleapis.com/v0/b/aline-perim-prod.appspot.com/o/images%2Fbanner-1.webp?alt=media&token=612de045-02f5-4d81-9c71-00431bc0709c"
          alt="Sacred Geometry"
          class="w-full h-48 object-cover"
        />
        <div class="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
      </div>

      <div class="p-6">
        <h3 class="text-2xl font-bold text-primary-dark mb-4">
          Seu Número de Alma é: {{ number }}
        </h3>

        <p class="text-gray-700 mb-6">
          {{ description }}
        </p>

        <div class="bg-primary/5 rounded-lg p-4">
          <div class="flex flex-col md:flex-row md:items-start gap-4">

            <div>
              <p class="font-medium text-primary-dark mb-2">O que o Número da Alma revela sobre você?</p>
              <p class="text-sm text-gray-600">
                O Número da Alma revela as motivações mais profundas e os desejos que guiam suas escolhas e atitudes. Ele reflete o aspecto mais íntimo da sua personalidade, trazendo à tona os anseios e aspirações que vêm do coração. Essa força interna influencia suas ações, relacionamentos, realizações e sentimentos, mostrando como você se expressa, especialmente nos momentos de intimidade e no lar. O Número da Alma é o que rege suas decisões intuitivas, alinhando suas escolhas com o seu eu mais verdadeiro e revelando o que realmente move cada aspecto da sua vida.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Continue Button -->
    <button
      @click="$emit('next')"
      class="w-full py-4 px-6 bg-primary text-white rounded-lg hover:bg-primary-dark transition-colors flex items-center justify-center gap-2"
    >
      <span>Descobrir Meu Número da Motivação</span>
      <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 8l4 4m0 0l-4 4m4-4H3" />
      </svg>
    </button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getSoulDescription } from '@/utils'

const props = defineProps<{
  number: number
}>()

const description = computed(() => getSoulDescription(props.number))

defineEmits(['next'])
</script>